export function formatDate(
  value: string | number | Date,
  options: { timeZone?: string; includeTime?: boolean; locale?: string } = {},
): string {
  const { timeZone, includeTime = true, locale } = options;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return 'Invalid date';

  try {
    return date.toLocaleString(locale, {
      timeZone,
      dateStyle: 'medium',
      ...(includeTime ? { timeStyle: 'short', timeZoneName: 'short' } : {}),
    });
  } catch {
    try {
      return date.toLocaleString();
    } catch {
      return date.toISOString();
    }
  }
}

export function isFutureDate(value?: string | number | Date | null): boolean {
  if (value === null || value === undefined || value === '') return false;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return false;
  return date.getTime() > Date.now();
}

export function formatRelativeTime(value: string | number | Date): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const diffMs = date.getTime() - Date.now();
  const diffMinutes = Math.round(diffMs / 60000);

  try {
    const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
    if (Math.abs(diffMinutes) < 60) {
      return rtf.format(Math.round(diffMinutes), 'minute');
    }
    const diffHours = Math.round(diffMinutes / 60);
    if (Math.abs(diffHours) < 24) {
      return rtf.format(diffHours, 'hour');
    }
    const diffDays = Math.round(diffHours / 24);
    return rtf.format(diffDays, 'day');
  } catch {
    return formatDate(value);
  }
}
